import React from "react";
import "../../../Tabs.css";
import RemainingDaysBadge from "../common/RemainingDaysBadge";
import {
  calculateParticipationStatus,
  openExternalUrl,
} from "../../../../../../utils/helpers";

const PlaceAdTable = ({
  adData,
  statusFilter,
  searchTerm,
  onViewAd,
  getStatusClass,
  getStatusText,
  selectedAds, // 부모에서 받은 상태
  onSelectAll, // 부모에서 받은 함수
  onSelectAd, // 부모에서 받은 함수
  keywordData, // 부모에서 받은 키워드 데이터
  onOpenRankCheck, // RankCheckModal 연결용 prop 추가
}) => {
  const approvedAds = adData.filter((ad) => ad.status === "APPROVED");
  const isAllApprovedSelected =
    approvedAds.length > 0 &&
    approvedAds.every((ad) => selectedAds.includes(ad.ad_id || ad.id));

  // 서버에서 이미 필터링된 데이터를 받으므로 정렬 제거
  const filteredAdData = adData;

  // API 연결 전 단계: 광고가 없으면 "등록된 광고가 없습니다" 메시지 표시
  if (!adData || adData.length === 0) {
    return (
      <div className="no-data-message">
        <p>등록된 광고가 없습니다</p>
      </div>
    );
  }

  return (
    <div className="ad-table-container">
      <table className="ad-table">
        <thead>
          <tr>
            <th style={{ width: "52px" }}>
              <input
                type="checkbox"
                checked={isAllApprovedSelected}
                onChange={onSelectAll(approvedAds)}
              />
            </th>
            <th>광고명</th>
            <th>메인키워드</th>
            <th>일일수량</th>
            <th>참여 현황</th>
            <th>시작순위</th>
            <th>현재순위</th>
            <th className="ad-period-th">기간(잔여기간)</th>
            <th className="ad-status-cell">진행상황</th>
            <th>상세보기</th>
          </tr>
        </thead>
        <tbody>
          {filteredAdData.map((ad) => (
            <tr key={ad.ad_id || ad.id}>
              <td>
                <input
                  type="checkbox"
                  checked={selectedAds.includes(ad.ad_id || ad.id)}
                  onChange={() => onSelectAd(ad.ad_id || ad.id)}
                  disabled={ad.status !== "APPROVED"}
                />
              </td>
              <td className="ad-name-cell">
                <img
                  src={ad.imageUrl || "/logo192.png"}
                  alt={ad.missionName || "광고 이미지"}
                  className="ad-image"
                  onError={(e) => {
                    e.target.src = "/logo192.png";
                  }}
                />
                <div className="ad-name-content">
                  <span
                    className="ad-name-link"
                    title={ad.missionName || "-"}
                    onClick={() => {
                      if (ad.productUrl) {
                        openExternalUrl(ad.productUrl);
                      }
                    }}
                  >
                    {ad.missionName || "-"}
                  </span>
                </div>
              </td>
              <td>
                <span
                  style={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    display: "block",
                  }}
                  title={(() => {
                    const keywords = keywordData[ad.ad_id] || [];
                    const mainKeyword = keywords.find((k) => k.type === "MAIN");
                    return mainKeyword?.name || ad.mainKeyword || "-";
                  })()}
                >
                  {(() => {
                    const keywords = keywordData[ad.ad_id] || [];
                    const mainKeyword = keywords.find((k) => k.type === "MAIN");
                    return mainKeyword?.name || ad.mainKeyword || "-";
                  })()}
                </span>
              </td>
              <td>
                {ad.dailyQuantity ? ad.dailyQuantity.toLocaleString() : "-"}
              </td>
              <td>{calculateParticipationStatus(ad)}</td>
              <td>
                {(() => {
                  const keywords = keywordData[ad.ad_id] || [];
                  const mainKeyword = keywords.find((k) => k.type === "MAIN");
                  const rank = mainKeyword?.initialRank || ad.initialRank;
                  return rank ? `${rank}위` : "-";
                })()}
              </td>
              <td>
                <span
                  style={{
                    color: "#007bff",
                    fontWeight: "600",
                    cursor: "pointer",
                    textDecoration: "underline",
                  }}
                  title="순위 체크 그래프 보기"
                  onClick={() => {
                    if (onOpenRankCheck) {
                      onOpenRankCheck(ad);
                    }
                  }}
                >
                  {(() => {
                    const keywords = keywordData[ad.ad_id] || [];
                    const mainKeyword = keywords.find((k) => k.type === "MAIN");
                    const rank = mainKeyword?.currentRank || ad.currentRank;
                    return rank ? `${rank}위` : "-";
                  })()}
                </span>
              </td>
              <td className="ad-period-cell">
                <div className="ad-period">
                  <span className="ad-period-range">
                    {ad.startDate
                      ? ad.startDate.split("T")[0].slice(5)
                      : "-"}{" "}
                    ~{" "}
                    {ad.endDate ? ad.endDate.split("T")[0].slice(5) : "-"}
                  </span>
                  <div className="ad-period-days">
                    <RemainingDaysBadge
                      startDate={ad.startDate}
                      endDate={ad.endDate}
                      status={ad.status}
                      withParens
                    />
                  </div>
                </div>
              </td>
              <td className="ad-status-cell">
                <span className={`status-badge ${getStatusClass(ad.status)}`}>
                  {getStatusText(ad.status)}
                </span>
              </td>
              <td>
                <button
                  className="view-button"
                  onClick={() => {
                    const enhancedAdData = {
                      ...ad,
                      mainKeywordName: keywordData[ad.ad_id]?.name || "-",
                      subKeywordNames: keywordData[ad.ad_id]?.subKeywords || [],
                    };
                    onViewAd(enhancedAdData);
                  }}
                >
                  상세보기
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default PlaceAdTable;
